<template>
    <td class="clicavel" :class="cellClass" :tabindex="index" @click="toggleEdit">
        <span v-if="!isEditing">{{ displayValue }}</span>
        <input
            v-if="isEditing"
            ref="inputEl"
            :type="inputType"
            v-model="localValue"
            @keydown.enter.prevent="commitEdit"
            @blur="commitEdit"
            required
        />
        <slot></slot>
    </td>
</template>

<script>
export default {
    props: {
        value: [String, Number, Date, Array],
        inputType: { type: String, default: "text" },
        displayValue: [String, Number, Date],
        index: Number,
        /** Classe extra no td (ex.: coluna estreita no PainelEdicao) */
        cellClass: { type: String, default: "" },
    },
    data() {
        return {
            isEditing: false,
            localValue: this.value,
        };
    },
    watch: {
        value(newVal) {
            if (!this.isEditing) {
                this.localValue = newVal;
            }
        },
    },
    methods: {
        toggleEdit() {
            if (this.isEditing) return;
            this.isEditing = true;
            this.localValue = this.value;
            this.$nextTick(() => this.$refs.inputEl?.focus?.());
        },
        commitEdit() {
            if (!this.isEditing) return;
            this.isEditing = false;

            if (this.localValue == this.value) return;

            if (
                (isNaN(this.localValue) && this.localValue instanceof Number) ||
                this.localValue < 0 ||
                (this.localValue == "" && this.inputType == "number")
            ) {
                this.localValue = 0;
            }
            this.$emit("update:value", this.localValue);
        },
    },
};
</script>
